import React from 'react';
import './style.scss';

interface Props {
  className: string;
}

const LandingFightDescription = ({ className }: Props) => (
  <div className={className}>
    <div className='lfs-description'>
      <h2 className='lfs-desc-wording'>gameplay</h2>
      <p className='lfs-desc-text body-1'>
        Fight against other players in PvP mode, pimp your Nifty Hand and wager
        hand cream over battles.
        <br />
        <br />
        In the battle, players get two or more hands of each symbol. As usual,
        rock crushes scissors, scissors cut paper and paper covers rock. The
        loser loses a hand.
        <br />
        <br />
        Winner takes all hand cream.
      </p>
    </div>
  </div>
);

export default LandingFightDescription;
